import { useEffect, useState } from 'react';
import type { CharacterProfile } from '../types';

interface IdleFighterSpriteProps {
  character: CharacterProfile;
  fastMode?: boolean;
  label?: string;
  paused?: boolean;
  side?: 'left' | 'right';
}

export function IdleFighterSprite({ character, fastMode = false, side, label, paused = false }: IdleFighterSpriteProps) {
  const [previewReady, setPreviewReady] = useState(true);
  const previewKind = fastMode ? 'fast' : 'preview';
  const preview = `/assets/characters/${character.id}/idle/previews/${character.id}_idle_${previewKind}.gif?v=20260717-5`;
  const master = `/assets/characters/${character.id}/idle/master-stance.png`;

  useEffect(() => {
    let live = true;
    const preload = new Image();
    setPreviewReady(true);
    preload.onload = () => { if (live) setPreviewReady(true); };
    preload.onerror = () => { if (live) setPreviewReady(false); };
    preload.src = preview;
    return () => { live = false; };
  }, [preview]);

  const animated = previewReady && !paused;

  return (
    <figure className={`idle-fighter idle-fighter--${character.id}${side ? ` idle-fighter--${side}` : ''}`} aria-label={label ?? `${character.name} waiting in a fighting stance`}>
      <img
        key={`${character.id}-${animated ? 'animated' : 'neutral'}`}
        className="idle-fighter__animation"
        src={animated ? preview : master}
        alt=""
        width="512"
        height="512"
        data-animation-frame-count={animated ? 8 : 1}
      />
    </figure>
  );
}
